const PATH_MAP = {
  stations: 'hollometers',
  plots: 'plot-config',
}

export const resolveNavPath = (path) => PATH_MAP[path] ?? path
